import { Outlet } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { AuthProvider } from '../auth/AuthContext';

/**
 * Router root. Provides antd's App context (message/modal/notification) and the AuthProvider,
 * both of which must sit inside the router tree (AuthProvider uses useNavigate + App.useApp).
 */
export default function RootLayout() {
  return (
    <AntdApp>
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </AntdApp>
  );
}
